import { render, staticRenderFns } from "./ThePopin.vue?vue&type=template&id=2d57668d&"
import script from "./ThePopin.vue?vue&type=script&lang=js&"
export * from "./ThePopin.vue?vue&type=script&lang=js&"
import style0 from "./ThePopin.vue?vue&type=style&index=0&id=2d57668d&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheLogo: require('/opt/build/repo/components/TheLogo.vue').default})
